import CustomiseOffersSidebar from './CustomiseOffersSidebar.module';

export default CustomiseOffersSidebar;
